export enum EMyBikeEvents {
    MY_BIKE_TOGGLE = 'myBike:toggle',
    SCROLL_TO = 'scrolling:scrollTo',
}
